import { MODAL_HIDDEN, MODAL_DATA_LOADED } from '../actions/constants';
import ModalExportToSheets from '../components/modals/ModalExportToSheets';

const INITIAL_STATE = {
  rowLimit: 0,
  queryTimeoutSeconds: 0,
  isAdmin: false,
};

const modalExportToSheets = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      if (action.payload.modal === ModalExportToSheets) {
        return {
          ...INITIAL_STATE,
          rowLimit: action.payload.json._rowLimit,
          queryTimeoutSeconds: action.payload.json._queryTimeoutSeconds,
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export default modalExportToSheets;
